<template>
    <article class="cause-single partner-single cause-item relative">
        <button type="button" class="cause-single__back btn-empty-wrapper absolute" @click="clickHandler">
            <Close icon="back" color-class="text-white"></Close>
        </button>
        <div class="cause-item__feature" v-if="cause.img !== undefined && cause.img.length > 0">
            <swiper ref="intro" :options="options">
                <swiper-slide v-for="(url, index) in getNposJson(cause.img)" :key="index">
                    <div class="cause-item__slide relative">
                        <img loading="lazy" class="absolute top-0 left-0 object-center object-cover h-full w-full"
                            :src="getNposImage(url)" :alt="
                                getNposContent('title') || $t('Retail Partner')
                            " />
                    </div>
                </swiper-slide>
                <div class="swiper-pagination swiper-pagination-bullets" slot="pagination"></div>
            </swiper>
        </div>

        <div class="cause-item__body">
            <header v-if="cause.title !== undefined && cause.title" class="mb-4">
                <h2 class="cause-item__title text-text font-bold cursor-pointer">
                    {{ getNposContent("title") }}
                </h2>

                <div class="partner-type text-14 tracking-normal text-content" v-if="
                    cause.categories && cause.categories.name !== undefined
                ">
                    {{ getLocalizationData(cause.categories.name) }}
                </div>
            </header>

            <div class="cause-item__content full-content mb-8">
                <div class="partner-description mb-4" :class="{ 'full-content': fullContent }"
                    v-if="cause.desc !== undefined && cause.desc" v-html="getNposContent('desc')">
                </div>
                <div class="partner-description mb-4" :class="{ 'full-content': fullContent }"
                    v-if="cause.covid !== undefined && cause.covid" v-html="getNposContent('covid')">
                </div>
                <div class="partner-description mb-4" :class="{ 'full-content': fullContent }" v-if="
                    cause.safety_precautious !== undefined &&
                    cause.safety_precautious
                " v-html="getNposContent('safety_precautious')">
                </div>

                <button v-if="cause.max_discount > 0" class="border p-1 flex btn-discount justify-center mb-3">
                    <img class="" :srcset="
                        `${$store.state.appUrl}/img/pwa/dashboard-icons/tag.svg, ${$store.state.appUrl}/img/pwa/dashboard-icons/tag.svg`
                    " :src="`${$store.state.appUrl}/img/pwa/dashboard-icons/tag.svg`" alt="Discount Tag" width="14px"
                        height="auto" />
                    <span class="px-2 text-12">Save {{ cause.max_discount }}% Off</span>
                </button>

                <table class="partner-table pt-4">
                    <tbody>
                        <tr>
                            <td class="pr-3">
                                <PartnerIcons icon="clock" classes="icon-color" />
                            </td>
                            <td>
                                <span v-if="
                                    cause.is_open !== undefined &&
                                    cause.is_open
                                " class="text-12 tracking-normal text-cause_text" :class="{
    'is-open':
        cause.is_open &&
        cause.is_open === 'Open',
    'is-close':
        cause.is_open &&
        cause.is_open !== 'Open',
}">{{ openClose }}
                                </span>
                            </td>
                        </tr>
                        <tr>
                            <td></td>
                            <td>
                                <div v-if="timeBoard">
                                    <ul>
                                        <li v-for="day in days" class="mb-1">
                                            <template v-if="
                                                timeBoard[day] !==
                                                undefined &&
                                                timeBoard[day]
                                            ">
                                                <div class="flex" :class="{
                                                    'font-bold':
                                                        timeBoard[day]
                                                            .today,
                                                }">

                                                    <span class="partner-day-name table" v-if="
                                                        !!timeBoard[day].day
                                                    ">{{
        timeBoard[day].day
}}
                                                    </span>
                                                    <template v-if="timeBoardClose[day] === undefined">
                                                        <span v-if="
                                                            !!timeBoard[day]
                                                                .start
                                                        ">{{
        $tConvert(timeBoard[day].start)
}}
                                                        </span>
                                                        <span v-if="
                                                            !!timeBoard[day]
                                                                .start &&
                                                            !!timeBoard[day]
                                                                .end
                                                        ">-
                                                        </span>
                                                        <span v-if="
                                                            !!timeBoard[day].end
                                                        ">{{
        $tConvert(timeBoard[day].end)
}}
                                                        </span>
                                                    </template>
                                                    <template v-else>
                                                        <span class="text-12 tracking-normal text-cause_text is-close">
                                                            {{ $t("Closed") }}
                                                        </span>
                                                    </template>
                                                </div>
                                            </template>
                                        </li>
                                    </ul>
                                </div>
                            </td>
                        </tr>

                        <!--                        <tr>-->
                        <!--                            <td class="pr-3">-->
                        <!--                                <PartnerIcons-->
                        <!--                                    icon="price"-->
                        <!--                                    classes="text-primary"-->
                        <!--                                />-->
                        <!--                            </td>-->
                        <!--                            <td>-->
                        <!--                                <span-->
                        <!--                                    class="text-12 tracking-normal text-cause_text"-->
                        <!--                                >-->
                        <!--                                    {{ price }}-->
                        <!--                                </span>-->
                        <!--                            </td>-->
                        <!--                        </tr>-->

                        <!-- <tr>
                            <td class="pr-3">
                                <PartnerIcons icon="discount" classes="text-primary" />
                            </td>
                            <td>
                                <span class="text-12 tracking-normal text-cause_text">
                                    {{ discount }}
                                </span>
                            </td>
                        </tr> -->

                        <tr v-if="!!cause.address">
                            <td class="pr-3">
                                <PartnerIcons icon="address" classes="icon-color" />
                            </td>
                            <td @click="route">
                                <span class="text-12 tracking-normal text-cause_text">
                                    {{ cause.address }}
                                </span>
                            </td>
                        </tr>

                        <tr v-if="!!cause.phone">
                            <td class="pr-3 align-baseline">
                                <PartnerIcons icon="phone" classes="icon-color" />
                            </td>
                            <td>
                                <ul>
                                    <li v-for="(phone, index) in getNposJson(
                                        cause.phone,
                                    )" :key="index" v-if="phone" class="text-12 tracking-normal text-cause_text mb-2">
                                        <a :href="`tel: ${phone}`">{{ phone }}</a>
                                    </li>
                                </ul>
                            </td>
                        </tr>

                        <tr v-if="cause.link !== undefined && cause.link">
                            <td class="align-middle">
                                <span class="cause-item__web-icon pr-3 icon-color">
                                    <svg height="25px" width="25px" data-name="Layer 1" id="Layer_1"
                                        viewBox="0 0 128 128" xmlns="http://www.w3.org/2000/svg">
                                        <path class="cls-1"
                                            d="M64,16A47.5,47.5,0,1,1,16.5,63.5,47.55,47.55,0,0,1,64,16m0-6.5a54,54,0,1,0,54,54,54,54,0,0,0-54-54Z" />
                                        <path class="cls-1"
                                            d="M65.08,16c2.09,0,5.78,3.66,8.93,11.69,3.71,9.46,5.75,22.18,5.75,35.81s-2,26.35-5.75,35.81c-3.15,8-6.83,11.69-8.93,11.69s-5.78-3.66-8.93-11.69C52.45,89.85,50.4,77.13,50.4,63.5s2-26.35,5.75-35.81C59.31,19.65,63,16,65.08,16m0-6.5c-11.7,0-21.18,24.18-21.18,54s9.48,54,21.18,54,21.18-24.18,21.18-54-9.48-54-21.18-54Z" />
                                        <line class="cls-2" x1="17.66" x2="112.5" y1="80.37" y2="80.37" />
                                        <line class="cls-2" x1="17.66" x2="112.5" y1="46.62" y2="46.62" />
                                    </svg>
                                    <!-- <WorldIcon /> -->
                                    <!-- <img class="" :srcset="
                                        `${$store.state.appUrl}/img/pwa/icons/globalization.svg, ${$store.state.appUrl}/img/pwa/icons/globalization.svg`
                                    " :src="`${$store.state.appUrl}/img/pwa/icons/globalization.svg`" alt="Globalization" width="auto"
                                        height="auto" /> -->
                                </span>
                            </td>
                            <td class="align-baseline">
                                <a v-if="
                                    cause.link !== undefined && cause.link
                                " :href="cause.link" target="_blank" class="flex text-14 tracking-normal text-link">
                                    {{ cause.link.replace("https://", "") }}
                                </a>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <button type="button"
                class="open-qr-reader-btn cause-item__btn btn-bgr-accent text-16 font-bold text-center w-full flex justify-center items-center"
                @click="saveChoice">
                <PartnerIcons icon="qr" classes="color-white mr-3 table" /><span>{{ $t("Scan to get offer") }}</span>
            </button>
        </div>

        <footer class="cause-item__footer">
            <div class="cause-item__map" v-if="cause.location !== undefined && cause.location.length > 0">
                <GoogleMapSingle :location="getNposJson(cause.location)"></GoogleMapSingle>
            </div>
        </footer>
        <QrCodeReader v-if="qrReaderVisible" @closeQrReader="closeQrReader" :partner-id="cause.id"
            :partner-name="getNposContent('title')" />
    </article>
</template>

<script>
import { Swiper, SwiperSlide, directive } from "vue-awesome-swiper";
import QrCodeReader from "../Partners/QrCodeReader_new";
import mixins from "../../config/mixins";
import Button from "../UI/Button";
import GoogleMapSingle from "../GoogleMap/GoogleMapSingle";
import Close from "../UI/Close";
import WorldIcon from "../Icons/WorldIcon";
import PartnerItem from "./PartnerItem";
import PartnerIcons from "../Icons/PartnersIcons";
export default {
    name: "PartnerSingle",

    mixins: [mixins.npos, mixins.location],

    components: {
        PartnerIcons,
        PartnerItem,
        WorldIcon,
        Close,
        GoogleMapSingle,
        Button,
        Swiper,
        SwiperSlide,
        QrCodeReader,
    },

    directives: {
        swiper: directive,
    },

    props: ["cause", "clickHandler"],

    data: function () {
        return {
            daysObj: {
                monday: this.$t("Mon"),
                tuesday: this.$t("Tue"),
                wednesday: this.$t("Wed"),
                thursday: this.$t("Thu"),
                friday: this.$t("Fri"),
                saturday: this.$t("Sat"),
                sunday: this.$t("Sun"),
            },
            days: [
                "monday",
                "tuesday",
                "wednesday",
                "thursday",
                "friday",
                "saturday",
                "sunday",
            ],
            fullContent: false,
            showSharePopup: false,
            options: {
                pagination: {
                    el: ".swiper-pagination",
                    clickable: true,
                },
            },
            causeShare: {
                title:
                    this.cause.title !== undefined
                        ? this.getNposContent("title")
                        : "",
                desc:
                    this.cause.desc !== undefined
                        ? this.getNposContent("desc")
                        : "",
                logo:
                    this.cause.logo !== undefined
                        ? this.getNposImage(this.cause.logo)
                        : "",
            },
            timeBoard: false,
            timeBoardClose: {},
            qrReaderVisible: false,
            currentUserLocation: null
        };
    },

    mounted() {
        this.$scrollToTop();
        this.saveViewStatistic();
        this.workDay();
    },

    computed: {
        openClose: function () {
            if (!!this.cause.is_open) {
                if (this.cause.is_open === "Open") {
                    return this.$t("Open now");
                }

                if (this.cause.is_open === "Close") {
                    return this.$t("Closed now");
                }
            }

            return "";
        },
        mapLink: function () {
            const userAddress = this.$getState('userAddress')
            return userAddress && this.cause.location ? "https://maps.google.com/maps?saddr=" + userAddress + "&daddr=" + this.cause.address : ''
        },
    },

    methods: {
        route() {
            this.mapLink && window.open(this.mapLink, '_blank')
        },
        closeQrReader: function () {
            this.qrReaderVisible = false;
        },
        workDay: function () {
            let date = new Date();
            let weekday = this.days[date.getDay() - 1];

            if (this.cause.timeboardclose !== undefined && this.cause.timeboardclose) {
                this.timeBoardClose = this.getNposJson(this.cause.timeboardclose);
            }

            if (this.cause.timeboard !== undefined) {
                let timeboard = this.getNposJson(this.cause.timeboard);
                const result = {
                    monday: {},
                    tuesday: {},
                    wednesday: {},
                    thursday: {},
                    friday: {},
                    saturday: {},
                    sunday: {},
                };

                for (let key in timeboard) {
                    let arr = key.split("_");

                    result[arr[0]][arr[1]] = timeboard[key];
                    result[arr[0]].day = this.daysObj[arr[0]];

                    result[arr[0]].today = arr[0] === weekday;
                }

                this.timeBoard = result;
            } else {
                this.timeBoard = false;
            }
        },
        goToPartner: function () {
            alert("Go to partner");
        },
        openShare: function () {
            this.showSharePopup = true;
        },
        hideShare: function () {
            this.showSharePopup = false;
        },
        saveChoice: function () {
            this.qrReaderVisible = true;
        },
        saveViewStatistic: function () {
            this.$silentHttp.post("user/view_item", {
                type: "retailer",
                item_id: this.cause.id,
            });
        }
    },
};
</script>
